import { autoinject } from 'aurelia-dependency-injection';
import { bindable, bindingMode } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import config from '../../../config/config'; // todo change to local resource
import { State } from '../../../services/global-state'; // todo change to local resource
import { PayrazrService } from '../../../services/payrazr'; // todo change to local resource

// -----------------------------------------------------------------------------------------
// The initial intention of having this in its own control is to re-use portal-specific
// stuff without dirtying up this new standalone area. We should later copy over the
// functionality and decouple it from portal.
// -----------------------------------------------------------------------------------------
@autoinject
export class StatementDownloadLink {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) customerAccountId: string;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) documentKey: number;
	tooltipText: string;

	constructor(private state: State, private payrazrService: PayrazrService, private i18n: I18N) {
	}

	attached() {
		this.tooltipText = this.i18n.i18next.t('viewLatestStatementDocument', 'View latest statement document');
	}

	downloadStatement() {
		if (this.documentKey) {
			let downloadUrl = `${config.serviceUrl}/portal/${this.state.business.portalId}` +
				`/account/${this.customerAccountId}/document/${this.documentKey}`;
			this.payrazrService.downloadFile(downloadUrl, 'statement.pdf');
		}
	}
}
